/**
 * Пустая функция (no-operation).
 *
 * @param args Любые аргументы (игнорируются)
 * @returns void
 * @example
 * ```ts
 * // Использование как заглушки для callback'ов
 * const onClick = noop;
 *
 * // Использование как значения по умолчанию
 * function createButton({ onClick = noop }) {
 *   // ...
 * }
 *
 * // Использование в тестах
 * test('should call callback', () => {
 *   const callback = noop;
 *   // ...
 * });
 * ```
 */
export function noop() { }
